import { getID } from "src/libs/utilities"

const person = () : any[] => {
    return [
        {
            "id": getID("person"), 
            "data": {
                "id": getID("person"),
                "user": {                
                    "id": getID("user"),
                    "first_name": "Марфа Аристарховна",
                    "last_name": "Пузырина",
                    "description": "Местечковый начальник <br>из деревни Нижние Локотники.<p>Долгое время была голубем.",
                    "avatar" : "https://i.pinimg.com/736x/8e/70/28/8e7028aa09d9f5542d4c8ae819c091b0.jpg"
                },
                "isVertical": true,
                "hover_size": 3,
                "border": {
                    "borderWidth": 1,
                    borderRound: { border: "50%" }
                },
                "avatarWidth": 250,
                "avatarHeight": 250
            },
            defaultTitle: "Огромный круглый аватар"
        },
        {
            "id": getID("person"), 
            "data": { 
                "id": getID("person"), 
                "user": {
                    "id": getID("user"),
                    "first_name": "Вениамин",
                    "last_name": "Овечкин",
                    "description": "Формальный глава <br>Филимоновского поселкового совета<br>Ост-Яковского уезда Забубённой губернии",
                    "avatar" : "https://i.pinimg.com/736x/6b/ab/aa/6babaa8325d4a351836e59bad032a24a.jpg"
                },
                "isVertical": true,
                "hover_size": 3,
                "border": {
                    "borderWidth": 3, 
                },
                "avatarWidth": 90,
                "avatarHeight": 90,
            },
            defaultTitle: "Компактный строгий дизайн"
        },
        {
            "id": getID("person"), 
            "data": {
                "id": getID("person"),
                "user": {
                    "id": getID("user"),
                    "first_name": "Паулина",
                    "last_name": "Шикардос",
                    "description": "Заместитель главного директора по всему",
                    "avatar" : "https://i.pinimg.com/736x/9a/db/b1/9adbb1d530a9b7d47ebf8236a4234d26.jpg"
                },
                "isVertical": false,
                "hover_size": 3,
                "border": {
                    "borderWidth": 1,
                    borderRound: { border: 1 }
                },
                "avatarWidth": 110,
                "avatarHeight": 110
            },
            defaultTitle: "Сверх-компактный строгий дизайн"
        },
        {
            "id": getID("person"),
            "data": {
                "id": getID("person"),
                "user": {
                    "id": getID("user"),
                    "first_name": "Паулина",
                    "last_name": "Шикардос",
                    "description": "Заместитель главного директора по всему",
                    "avatar" : "https://i.pinimg.com/736x/9a/db/b1/9adbb1d530a9b7d47ebf8236a4234d26.jpg"
                },
                "isVertical": false,
                "hover_size": 3,
                "border": {
                    "borderWidth": 1,
                    borderRound: { border: "50%" }
                },
                "avatarWidth": 75,
                "avatarHeight": 75,
            },
            defaultTitle: "Сверх-компактный округлый дизайн"
        },
        {
            "id": getID("person"),
            "data": {
                "id": getID("person"),
                "user": {                
                    "id": getID("user"),
                    "first_name": "Гюзель",
                    "last_name": "Мансурова",
                    "description": "Девочка-припевочка",
                    "avatar" : "https://i.pinimg.com/736x/2b/19/2b/2b192be66d28b4bdd5ae1634faa54c8d.jpg"
                },
                "isVertical": true,
                "hover_size": 3,
                "border": {
                    "borderWidth": 1,
                    borderRound: { border: "1px" }
                },
                "avatarWidth": 350,
                "avatarHeight": 200,
            },
            defaultTitle: "Карточка"
        },
        {
            "id": getID("person"),
            "data": {
                "id": getID("person"),
                "user": {                
                    "id": getID("user"),
                    "first_name": "Авдотья",
                    "last_name": "Штык",
                    "description": "Местечковый начальник <br>из деревни Нижние Локотники.<p>Долгое время была голубем.",
                    "avatar" : "https://i.pinimg.com/736x/8e/70/28/8e7028aa09d9f5542d4c8ae819c091b0.jpg"
                },
                "isVertical": true,
                "hover_size": 3,
                "border": {
                    "borderWidth": 1,
                },
                "avatarWidth": 180,
                "avatarHeight": 420,
            },
            defaultTitle: "Узкая карточка"
        },
         {
            "id": getID("person"), 
            "data": {
                "id": getID("person"),
                "user": {                
                    "id": getID("user"),
                    "first_name": "Гюзель",
                    "last_name": "Мансурова",
                    "description": "Девочка-припевочка",
                    "avatar" : "https://i.pinimg.com/736x/2b/19/2b/2b192be66d28b4bdd5ae1634faa54c8d.jpg"
                },
                "isVertical": false,
                "hover_size": 3,
                "border": {
                    "borderWidth": 1,
                    borderRound: { border: "1px" }
                },
                "avatarWidth": 300,
                "avatarHeight": 150,
            },
            defaultTitle: "Длинная карточка"
        },
    ]
}
export default person